import React, { useState, useContext, useEffect, useMemo } from "react";
//Componentes
import FilterScreen from "../../components/filterScreen/FilterScreen";
import SearchInput from "../../components/searchInput/SearchInput";
import AddFilter from "../../components/addFilter/AddFilter";
import Swal from 'sweetalert2'

//Contextos
import activoContext from "../../context/activoContex/activoContex";
import authContext from "../../context/authentication/authContex";
import usuariosContext from "../../context/usuarios/usuariosContext";
import controlContext from "../../context/control/controlContext";

//Estilos
import './ProcedimientosProgramados.css';
import ProcsProgramadosList from "../../components/procsProgramadosList/ProcsProgramadosList";
import { ALERTSProcedimientosProgramados, ORIGENES, STATES, STATESProcsProgramados, TIPPROCS } from "../../utils/states";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHourglassEnd, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { useLocation } from "react-router-dom";

const ProcedimientosProgramados = () =>{
    const aContext = useContext(activoContext);
    const {procsProgramadosList,getMantenimientosProgramados,calcularMantenimientos, iniciarFiltrosProcsProgramados, modificarFiltrosEstado, modificarFiltrosRango, cargandoProcsProgramados, filtrosProcsProgramadosRango, filtrosProcsProgramadosEstado, filtrarProcsProgramados, filtrosProcsInicializados, initialState, reinitilizeFiltrosEstado} = aContext;
    
    const auContext = useContext(authContext);
    const { usuario, checkIfAdmin, checkIfAdminOrAdminNoABMs, checkIfSupervisor } = auContext;
    
    const uContext = useContext(usuariosContext);
    const {userListView} = uContext
    
    const {iniciarFiltros} = useContext(controlContext);

    const location = useLocation();

    //Recupera el codigo de activo para usarlo como filtro, caso que no este seteado se recibe null.
    const [filterByCodActivo, setFilterByCodActivo] = useState(localStorage.getItem('activoToSearch') || location?.state?.activoToSearch || null);
    
    // //Recupera el WorkSpace definido al seleccionar que tipo de procedimientos asociados al activo visualizar.
    const [wSpaceFromActivos, setWSpaceFromActivos] = useState(localStorage.getItem('workspaceSelected') || location?.state?.workspaceSelected || null);

    // //Recupera el ORIGEN definido al seleccionar que tipo de procedimientos asociados al activo visualizar.
    const [origenFromActivos, setOrigenFromActivos] = useState(localStorage.getItem('origen')|| location?.state?.origen || null);

    const procsProgramadosFromLocalStorage = useMemo(()=> localStorage.getItem('procsProgramados'),[]);
    const ordenesTrabajoFromLocalStorage = useMemo(()=> localStorage.getItem('ordenesTrabajo'),[]);
    const checklistRegFromLocalStorage = useMemo(()=> localStorage.getItem('checklistReg'),[]);

    const [procsFiltrados,setProcsFiltrados] = useState(undefined); 
    const [filtrosModificados, setFiltrosModificados] = useState(wSpaceFromActivos != null ? true : false);
    const [filter, setFilter] = useState((filterByCodActivo != null) ? filterByCodActivo : ''); //Si filterByCodActivo distinto de null se usa como filtro, si no se inicializa el filtro en ''.
    const [select,setSelect] = useState([])
    const [filterTipoActivos,setFilterTipoActivos] = useState([])
    const [showFilters,setShowFilter] = useState(false);
    const [selectedFilter, setSelectedFilter] = useState("");
    const [fromActivoList,setFromActivoList] = useState((localStorage.getItem('activoToSearch') != null));

    //Si se reciben procedimientos desde otra ventana se da por hecho que aun no se filtraron, en caso de false no se renderiza la lista hasta que esta este filtrada.
    const [procsFromLocalStorageFiltered,setProcsFromLocalStorageFiltered] = useState((procsProgramadosFromLocalStorage && procsProgramadosFromLocalStorage != 'null' &&  origenFromActivos &&  origenFromActivos != 'null') ? false : true);

    const [activeWorkSpace, setActiveWorkSpace] = useState((wSpaceFromActivos == null ) ? {todos: 1, vencidos: 0, porVencer:0 } : {todos: (wSpaceFromActivos == 'todos') ? 1 : 0, vencidos: (wSpaceFromActivos == 'vencidos') ? 1 : 0, porVencer: (wSpaceFromActivos == 'porVencer') ? 1 : 0});

    const aplicarFiltros = async (filtrosProp) => {
        modificarFiltrosEstado(filtrosProp.filterEstado);
        modificarFiltrosRango(usuario._id, filtrosProp.filterRango);
        setFiltrosModificados(true);
    }

    const handleWorkSpace = async(statusToDisplay) =>{
        if(filtrosModificados){
            setFiltrosModificados(false);
            handlerIniciarlizarFiltros(statusToDisplay);
        }

        setWSpaceFromActivos(null);

        let workspaceToSet = (statusToDisplay == 'todos') ? {todos: 1, vencidos: 0, porVencer: 0} : (statusToDisplay == 'vencidos') ? {todos: 0, vencidos: 1, porVencer: 0} : {todos: 0, vencidos: 0, porVencer: 1};
        let TIPOALERTA = (statusToDisplay == 'todos') ? ['VENC','PorVENC'] : (statusToDisplay == 'vencidos') ? ['VENC'] : ['PorVENC'];
        setActiveWorkSpace(workspaceToSet);
        let STATESProcsProgramados = (statusToDisplay == 'todos') ? ['PEND','PROG','COMPL'] : ['PEND','PROG'];
        const activosAllowed = usuario?.activosAllowed?.map(a => a.value) ?? [];
        const filterEstado = {...initialState.filtrosProcsProgramadosEstado, statesProcedimientos: STATESProcsProgramados, tipoAlerta: TIPOALERTA, activos: activosAllowed };
        // const filterRango = filtrosProcsProgramadosRango;
        const filterRango = initialState.filtrosProcsProgramadosRango;
        modificarFiltrosEstado(filterEstado);
        modificarFiltrosRango(usuario._id, filterRango);
    }

    const handleCalcularMantenimientos = async () => {
       calcularMantenimientos()
       .then(res => {
            if(res != 'Exito'){
                Swal.fire({
                    title: `Error`,
                    icon: 'warning',
                    text: ``,
                    showConfirmButton: true,
                    allowEnterKey: true
                });
                getMantenimientosProgramados();
            }else{
                Swal.fire({
                    title:  "Éxito",
                    icon: 'success',
                    text: `Se calcularon correctamente los mantenimientos!`,
                    showConfirmButton: true,
                    allowEnterKey: true
                });
            }
        })
        .catch(err => {
            console.log("err al calcular mantenimientos en ProcedimientosProgramados");
            console.log(err);
        })
       Swal.fire("Un aviso se mostrará al finalizar...");
    }

    const handlerIniciarlizarFiltros = async () => {    
        reinitilizeFiltrosEstado();        
    }

    const handlerInicializarFiltros = async () => {
        const state = STATES;
        const tipoAlerta = ALERTSProcedimientosProgramados;
        //let statesProcs = (statusToDisplay != null) ? (statusToDisplay == 'todos') ? ['PEND','PROG','COMPL'] : ['PEND','PROG'] : ['PEND','PROG','COMPL'];
        let statesProcs = ['PEND','PROG','COMPL'];
        await iniciarFiltros(state, usuario, tipoAlerta, TIPPROCS, 'consumos', statesProcs);
    }

    useEffect(()=>{
        // //Al utilizarlo por unica vez se remueve nuevamente para no arrastrarlo a traves de todos los componentes.
        if(localStorage.getItem('activoToSearch')) localStorage.removeItem('activoToSearch');
        if(localStorage.getItem('workspaceSelected')) localStorage.removeItem('workspaceSelected');
        if(localStorage.getItem('origen')) localStorage.removeItem('origen')
        else if(origenFromActivos && wSpaceFromActivos){
            //Si vienen desde otra vista estos valores pero no desde otra ventana, solo se inician los filtros nuevamente.
            iniciarFiltrosProcsProgramados(null, wSpaceFromActivos == 'vencidos' ? ['VENC'] : ['PorVENC'], TIPPROCS, ["PEND","PROG"], origenFromActivos);    
        }
    },[]);

    useEffect(()=>{
        if(!cargandoProcsProgramados){
            handlerInicializarFiltros();
            const activosAllowed = usuario?.activosAllowed?.map(a => a.value) ?? [];
            modificarFiltrosEstado({...initialState.filtrosProcsProgramadosEstado, activos: activosAllowed});
            modificarFiltrosRango(usuario._id, initialState.filtrosProcsProgramadosRango);
            setFiltrosModificados(true);
        };
    },[])

    useEffect(()=>{
        let procsFiltradosToSet;     

        if(procsProgramadosFromLocalStorage && procsProgramadosFromLocalStorage != "null" && !procsProgramadosList){
            procsFiltradosToSet = filtrarProcsProgramados(JSON.parse(procsProgramadosFromLocalStorage), filtrosProcsProgramadosEstado, filtrosProcsProgramadosRango, 'ProcedimientosProgramados');
        } 
        else if(!checkIfSupervisor()){
            procsFiltradosToSet = filtrarProcsProgramados(procsProgramadosList,filtrosProcsProgramadosEstado,filtrosProcsProgramadosRango,'ProcedimientosProgramados');
        }

        if(checkIfSupervisor()){ //Si el usuario logueado es Supervisor, mostrar solo los procedimientos visibles para el mismo.
            if(!procsFiltradosToSet) procsFiltradosToSet = procsProgramadosList?.filter(p => p.supervisorVisible) ?? [];
            else procsFiltradosToSet = procsFiltradosToSet?.filter(p => p.supervisorVisible) ?? [];
            procsFiltradosToSet = filtrarProcsProgramados(procsFiltradosToSet, {...filtrosProcsProgramadosEstado, activos: usuario?.activosAllowed?.map(a => a.value) ?? []}, filtrosProcsProgramadosRango, 'ProcedimientosProgramados');
        }

        setProcsFiltrados(procsFiltradosToSet);
        setTimeout(()=> !procsFromLocalStorageFiltered && setProcsFromLocalStorageFiltered(true), 3000);

    },[procsProgramadosList, filtrosProcsProgramadosEstado, filtrosProcsProgramadosRango]);

    return <div className="procedimientosProgramadosView">
        <div className="utilitiesDiv">
            <FilterScreen verFiltro={setShowFilter}/>
            {cargandoProcsProgramados && <FontAwesomeIcon icon={faSpinner} pulse className="rrIcon loadingReqList" id="progIcon"/>}
            <SearchInput filter={filter} buscar={setFilter}/>
            <button className="calcMantBtn" onClick={() => handleCalcularMantenimientos()}>Calcular Programación</button>
        </div>
        <div className="handleWorkSpaceDiv">
            <label className={`${(Object.keys(activeWorkSpace).some(k => k == 'todos' && activeWorkSpace[k] == 1 )) && 'selected '} optionWorkspace`} onClick={()=>handleWorkSpace("todos")}>TODOS</label>
            <label className={`${(Object.keys(activeWorkSpace).some(k => k == 'vencidos' && activeWorkSpace[k] == 1 )) && 'selected '} optionWorkspace`} onClick={()=>handleWorkSpace("vencidos")}>VENCIDOS</label>
            <label className={`${(Object.keys(activeWorkSpace).some(k => k == 'porVencer' && activeWorkSpace[k] == 1 )) && 'selected '} optionWorkspace`} onClick={()=>handleWorkSpace("porVencer")}>POR VENCER</label>
        </div>
        {(procsFiltrados == undefined || !procsFromLocalStorageFiltered) ? <h3 className="warningStatusMsg">Cargando<span>.</span><span>.</span><span>.</span></h3> 
        : (procsFiltrados.length > 0) ? <ProcsProgramadosList procsProgramados={procsFiltrados} setProcsProgramados={setProcsFiltrados} filter={filter} checkIfAdmin={checkIfAdmin} checkIfAdminOrAdminNoABMs={checkIfAdminOrAdminNoABMs} ordenesTrabajoFromLocalStorage={ordenesTrabajoFromLocalStorage} checklistRegFromLocalStorage={checklistRegFromLocalStorage}/>
        : <h3 className="warningStatusMsg">No hay procedimientos programados {Object.keys(activeWorkSpace).map(k => (k == 'vencidos' && activeWorkSpace[k] == 1) ? 'Vencidos' : (k == 'porVencer' && activeWorkSpace[k] == 1) ? 'Por Vencer' : '')} </h3>}

        {showFilters &&
        <div className="filterContainer">
            <AddFilter 
            usuarios={userListView} item={selectedFilter} 
            cerrar={setShowFilter} filtro={{filtrosRango: filtrosProcsProgramadosRango, filtrosEstado: filtrosProcsProgramadosEstado}} aplicarFiltros={aplicarFiltros} 
            workspace={activeWorkSpace} selct={select} setSelec={setSelect} filterTipoActivos={filterTipoActivos} setFilterTipoActivos={setFilterTipoActivos} componentePadre="ProcedimientosProgramados"/>
        </div>
        }
    </div>

}

export default ProcedimientosProgramados;